jQuery  (
        function()
            {
            var setCookie = function(i, v, d)
                    {
                    const s = new Date();

                    s.setTime(s.getTime() + (d * 24 * 60 * 60 * 1000));                                        

                    let e = "expires="+ s.toUTCString();                                    

                    const c = i + "=" + v + ";" + e + ";path=/";

                    console.log(c);
                    document.cookie = c;                                 

                    return getCookie(i);
                    }


            var getCookie = function(cn)
                        {
                        let n = cn + "=";
                        let decodedCookie = decodeURIComponent(document.cookie);
                        let ca = decodedCookie.split(';');

                        for(let i = 0; i < ca.length; i++)
                            {
                            let c = ca[i];
                            
                            while (c.charAt(0) == ' ')
                                {
                                c = c.substring(1);
                                }
                            
                            if (c.indexOf(n) == 0)
                                {
                                return c.substring(n.length, c.length);
                                }
                            }

                        return false;
                        }


            var getStorageType = function(t)
                        {
                        var storage = false;

                        switch(t)
                            {
                            case 'local':
                                    storage = window.localStorage;
                                break;
                            case 'session':
                                    storage = window.sessionStorage;
                                break;
                            } 

                        return storage;
                        }


            var removeFromStorage = function(t = null, i = null)
                        {
                        var storage = getStorageType(t);
            
                        storage.removeItem(i);

                        return;
                        }


            var getFromStorage = function(t = null, i = null)
                        {
                        var result = false;
                        var storage = getStorageType(t);

                        if(storage)
                            {
                            if(i == null)
                                {
                                result = storage;
                                }
                                else    {                                                
                                        result = storage.getItem(i);
                                        }
                            }
                        return result ?? false;
                        }


            var getCartItems = function()
                        {                                               
                        //var shoppingCart = JSON.parse( getFromStorage('session', 'shoppingCart') );
                        var shoppingCart = JSON.parse( getFromStorage('local', 'shoppingCart') );
                            
        
                        if(shoppingCart !== false)
                            {
                            var count = shoppingCart.count;
                            var subtotal = shoppingCart.costSummary.subTotal;
                            
                            if(count > 0)
                                {
                                $('.cart-count').html(count);
                                $('.cart-subtotal').html( subtotal.toFixed(2) );

                                $('.cart-label').addClass('d-none');
                                $('.cart-stats').removeClass('d-none');
                                }
                            }                        
                        }


            var moveStorageToCookie = function(t, i, d = 0)    
                        {       
                        var result = false; 

                        var v = getFromStorage(t, i);  
                                                    
                        if(!v == false)
                            {
                            var result = setCookie(i, v, d);                                                
                            removeFromStorage(t, i);
                            }
                        
                        return result;
                        }


            var moveStorageToStorage = function(st, i, dt)
                        {
                        var result = false;
                        const d = getFromStorage(st, i);

                        if(d)
                            {
                            getStorageType(dt).setItem(i, d);
                            result = getStorageType(dt).getItem(i); 
                            }

                        if(result)
                            {
                            removeFromStorage(st, i);
                            }

                        return result;
                        }

                        
            //moveStorageToStorage('local', 'shoppingCart', 'session');
            //getCartItems(); 
            }
        );